import Box from '@mui/material/Box';
import { keyframes } from '@mui/material/styles';

interface SignalPulseProps {
  size: number;
  pulse?: boolean;
  color?: string;
}

const ping = keyframes`
  0%   { transform: scale(1); opacity: 0.8; }
  100% { transform: scale(2.8); opacity: 0; }
`;

export default function SignalPulse({ size, pulse = true, color }: SignalPulseProps) {
  if (!color) {
    return null;
  }
  return (
    <Box sx={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
      {pulse && (
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            borderRadius: '50%',
            backgroundColor: color,
            animation: `${ping} 1.6s ease-out infinite`,
            '@media (prefers-reduced-motion: reduce)': { animation: 'none', opacity: 0 },
          }}
        />
      )}
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: '100%',
          borderRadius: '50%',
          backgroundColor: color,
        }}
      />
    </Box>
  );
}
